<header class="flex header p-2">
  <h2>{{ 'Second_Quality_Roll_Modal_Title' | translateWF: 'Add Second Quality Roll' }}</h2>
</header>

<section class="content">
  <!-- Existing Second Quality Rolls Summary -->
  @if (secondQualityRolls.length > 0) {
    <div class="existing-rolls-summary mb-4">
      <h4 class="m-0 mb-2">{{ 'Second_Quality_Roll_Modal_ExistingRolls' | translateWF: 'Existing Second Quality Rolls' }}</h4>
      <p-table [value]="secondQualityRolls" [tableStyle]="{ 'min-width': '100%' }" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'Second_Quality_Roll_Modal_RollNumber' | translateWF: 'Roll Number' }}</th>
            <th>{{ 'Second_Quality_Roll_Modal_FabricCode' | translateWF: 'Fabric Code' }}</th>
            <th>{{ 'Second_Quality_Roll_Modal_Quality' | translateWF: 'Quality' }}</th>
            <th>{{ 'Second_Quality_Roll_Modal_Weight' | translateWF: 'Weight (lbs)' }}</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-roll>
          <tr>
            <td>{{ roll.number }}</td>
            <td>{{ roll.expectedFabricCode || roll.itemCode }}</td>
            <td>{{ rollQualityValues[roll.rollQuality] || '-' }}</td>
            <td>{{ roll.finalWeight?.weightInLbs ?? roll.grossQuantity ?? roll.netQuantity ?? '---' }}</td>
            <td>
              <p-button
                icon="pi pi-print"
                [text]="true"
                [rounded]="true"
                severity="secondary"
                size="small"
                (onClick)="printFinalLabel(roll.number)"
                [pTooltip]="'Second_Quality_Roll_Modal_PrintLabel' | translateWF: 'Print Label'"
              />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="4" class="text-right font-bold">
              {{
                'Second_Quality_Roll_Modal_TotalWeight'
                  | translateWF
                    : 'Total
            Weight'
              }}:
            </td>
            <td class="font-bold">{{ totalSecondQualityWeight() | number: '1.2-2' }} lbs</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }

  <!-- Add New Roll Form -->
  <h4 class="m-0 mb-2">{{ 'Second_Quality_Roll_Modal_AddNewRoll' | translateWF: 'Add New Roll' }}</h4>
  <form [formGroup]="form">
    <div class="grid">
      <!-- Fabric Code -->
      <div class="col-12 md:col-6">
        <label for="fabricCode" class="block mb-1">
          {{
            'Second_Quality_Roll_Modal_FabricCode'
              | translateWF
                : 'Fabric
          Code'
          }}
          *
        </label>
        <p-select
          id="fabricCode"
          formControlName="fabricCode"
          [options]="fabricCodeOptions()"
          placeholder="{{ 'Second_Quality_Roll_Modal_SelectFabricCode' | translateWF: 'Select Fabric Code' }}"
          styleClass="w-full"
          appendTo="body"
          [class.ng-invalid]="isFieldInvalid('fabricCode')"
          [class.ng-dirty]="isFieldInvalid('fabricCode')"
        />
        @if (isFieldInvalid('fabricCode')) {
          <small class="p-error">{{
            'Second_Quality_Roll_Modal_FabricCodeRequired'
              | translateWF
                : 'Fabric code is
          required'
          }}</small>
        }
      </div>

      <!-- Quality -->
      <div class="col-12 md:col-6">
        <label for="quality" class="block mb-1"> {{ 'Second_Quality_Roll_Modal_Quality' | translateWF: 'Quality' }} * </label>
        <p-select
          id="quality"
          formControlName="quality"
          [options]="rollQualityOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="{{ 'Second_Quality_Roll_Modal_SelectQuality' | translateWF: 'Select Quality' }}"
          styleClass="w-full"
          appendTo="body"
          [class.ng-invalid]="isFieldInvalid('quality')"
          [class.ng-dirty]="isFieldInvalid('quality')"
        />
        @if (isFieldInvalid('quality')) {
          <small class="p-error">{{ 'Second_Quality_Roll_Modal_QualityRequired' | translateWF: 'Quality is required' }}</small>
        }
      </div>

      <!-- Weight -->
      <div class="col-12 md:col-6">
        <label for="weightInLbs" class="block mb-1">
          {{
            'Second_Quality_Roll_Modal_WeightInLbs'
              | translateWF
                : 'Weight
          (lbs)'
          }}
          *
        </label>
        <p-inputNumber
          id="weightInLbs"
          formControlName="weightInLbs"
          mode="decimal"
          [minFractionDigits]="2"
          [maxFractionDigits]="3"
          [min]="0.01"
          placeholder="0.00"
          styleClass="w-full"
          [inputStyleClass]="isFieldInvalid('weightInLbs') ? 'ng-invalid ng-dirty' : ''"
        />
        @if (isFieldInvalid('weightInLbs')) {
          <small class="p-error">{{
            'Second_Quality_Roll_Modal_WeightRequired'
              | translateWF
                : 'Weight must be greater than
          0'
          }}</small>
        }
      </div>
    </div>
  </form>
</section>

<footer>
  <p-button [label]="'Second_Quality_Roll_Modal_Cancel' | translateWF: 'Cancel'" variant="outlined" (onClick)="onClose()" [disabled]="isSubmitting()" />
  <p-button [label]="'Second_Quality_Roll_Modal_Add' | translateWF: 'Add Roll'" (onClick)="onSave()" [disabled]="form.invalid || isSubmitting()" [loading]="isSubmitting()" />
</footer>
